import { getModuleHelpConfig } from "../../config/moduleHelp";
import { ModuleHelpProvider } from "../../context/ModuleHelpContext";
import { ModuleHelpRail } from "./ModuleHelpRail";
import { ModuleIntroModal } from "./ModuleIntroModal";

export function ModuleHelpShell({ moduleId, children }) {
  const config = getModuleHelpConfig(moduleId);
  if (!config) {
    return children;
  }

  return (
    <ModuleHelpProvider moduleId={moduleId}>
      <div className="flex flex-col xl:flex-row xl:items-start gap-4 xl:gap-6">
        <div className="min-w-0 flex-1 order-2 xl:order-1">{children}</div>
        <ModuleHelpRail className="order-1 xl:order-2 w-full xl:w-[272px] xl:sticky xl:top-4 shrink-0" />
      </div>
      <ModuleIntroModal />
    </ModuleHelpProvider>
  );
}
